/**
 * 
// 描边连接类型
export type StrokeLinejoin = 'miter' | 'round' | 'bevel';

// 描边端点类型
export type StrokeLinecap = 'butt' | 'round' | 'square';

// 主题
export type Theme = 'outline' | 'filled' | 'two-tone' | 'multi-color';
 * 
 */

const base = {
    size: 16,
    strokeWidth: 4,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
}

function initColors(
    theme, 
    customColor = ['#000000', '#000000', '#000000', '#000000'], 
    isCurrentColor = true) {
    const colors = Array(2).fill(customColor[0]);
    // 以下为留白逻辑
    // 线性
    if (theme === 'outline') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[0];
        colors[1] = '#ffffff';
        colors[2] = isCurrentColor ? 'currentColor' : customColor[0];
    }
    // 面性
    if (theme === 'filled') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[1] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[2] = '#ffffff';
    }
    // 双色
    if (theme === 'two-tone') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[0];
    }
    // 多色
    if (theme === 'multi-color') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[2];
    }
    return colors;
}

function initSize(size, isFontSize) {
    return isFontSize ? '1em' : `${size}px`;
}

export default {
    name: 'commonIconAdd2',
    cName: '新增2',
    render(config) {
        const props = {
            ...base,
            ...config,
            size: initSize(config.size, config.isFontSize),
            colors: initColors(config.theme, config.colors, config.isCurrentColor)
        }
        return this.svgFn(props);
    },
    svgFn: (props) => (
        `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" fill="none" fill-rule="evenodd">
                <g transform="translate(8.000000, 8.000000)" stroke="${props.colors[0]}" stroke-linecap="${props.strokeLinecap}" stroke-width="${props.strokeWidth}" stroke-linejoin="${props.strokeLinejoin}">
                    <line x1="16" y1="-1.65145675e-14" x2="16" y2="32"></line>
                    <line x1="32" y1="16" x2="-6.32383035e-13" y2="16"></line>
                </g>
            </g>
        </svg>
        `
    )
};
